import { useAuthContext } from '../contexts/Auth';

const moment = require('moment'); // require
const objectPath = require("object-path");

const dateRegexp = /{{[-+]?[0-9]{1,4}}}+/g
const formRegexp = /\[\[((\w+)(.\w+|\[\d+\])+?)\]\]/g

export const useIframe = () => {

  const { auth } = useAuthContext();

  const resolveMatches = (text, form) => {
    const withFormMatches = form ? revolveFormMatches(text, form) : text;
    const withAuthMatches = revolveFormMatches(withFormMatches, {auth});
    const withDateMatches = revolveDateMatches(withAuthMatches);
    return withDateMatches;
  }

  const revolveDateMatches = (text) => {
    const matches = text.match(dateRegexp);
    if(matches){
      return text.replace(dateRegexp, (match) => {
        const hours = match.replace("{{", "").replace("}}", "");
        return moment().add(hours, 'hours').unix() * 1000;
      })
    }else{
      return text;
    }
  }

  const revolveFormMatches = (text, form) => {
    const matches = text.match(formRegexp);
    if(matches){
      return text.replace(formRegexp, (match) => {
        const path = match.replace("[[", "").replace("]]", "");
        return objectPath.get(form, path) || "";
      })
    }else{
      return text;
    }
  }

  return { resolveMatches };

}